import React, { useState } from 'react';

const LogoutPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showLogoutPopup,setShowLogoutPopup] = useState<boolean>(false);

    const logoutToggleHandler = () => {
        setShowLogoutPopup(!showLogoutPopup);
    }
	
	return <Component showLogoutPopup={showLogoutPopup} logoutPopupToggleHandler={logoutToggleHandler} {...props}/>;
};

export default LogoutPopupHOC;   